import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  coreData: {},
  allEvents: [],
  league_events: {},
  events: {},
  sportTypeEvents: {},
  sport_countries: {},
  sport_highlights: {},
  league_groups: [],
  bet_groups: [],
  sport_type_league_groups: {},
  leagues: {},
  league_group_leagues: {},
  bet_types: [],
  available_sport_types: [],
  sport_hasGamesToday: {},
  market_filters: [],
  top_bets: [],
  favGamesList: [],
  marketTypeFav: [],
  casinoGameFav: [],
  recentCasinoGame: [],
  myCasinoGameList: [],
  leagues_events_timelines: {},
  top_matches: [],
  rewardPromotion: null,
  openTournamentDetail: false,
  tournamentData: null,
  openArchivedCampaign: false,
  openCompletedTournament: false,
  completedTournamentData: null,
};
const coreDataSlice = createSlice({
  name: 'coreData',
  initialState,
  reducers: {
    updateCoreData: (state, action) => {
      state.coreData = action.payload.coreData;
    },
    addAllEvents: (state, action) => {
      state.allEvents = action.payload.allEvents;
    },
    updateEvents: (state, action) => {
      state.events = action.payload.events;
    },
    updateSportTypeEvents: (state, action) => {
      state.sportTypeEvents = action.payload.sportTypeEvents;
    },
    updateTopBets: (state, action) => {
      state.top_bets = action.payload.top_bets;
    },
    updateLeagueGroups: (state, action) => {
      state.league_groups = action.payload.league_groups;
    },
    updateBetGroup: (state, action) => {
      state.bet_group = action.payload.bet_group;
    },
    updateBetTypes: (state, action) => {
      state.bet_types = action.payload.bet_types;
    },
    updateLeagueEvents: (state, action) => {
      state.league_events = action.payload.league_events;
      state.leagues_matches_count = action.payload.leagues_matches_count;
      state.sport_type_matches_count = action.payload.sport_type_matches_count;
      state.leagues_events_timelines = action.payload.leagues_events_timelines;
    },
    updateSportCountries: (state, action) => {
      state.sport_countries = action.payload.sport_countries;
    },
    updateSportTypeLeagueGroups: (state, action) => {
      state.sport_type_league_groups = action.payload.sport_type_league_groups;
    },
    updateLeagueGroupLeagues: (state, action) => {
      state.league_group_leagues = action.payload.league_group_leagues;
    },
    updateLeagues: (state, action) => {
      state.leagues = action.payload.leagues;
    },
    updateSportHighlights: (state, action) => {
      state.sport_highlights = action.payload.sport_highlights;
    },
    updateFavGamesList: (state, action) => {
      state.favGamesList = action.payload.favGamesList;
    },
    updateMarketTypeFavs: (state, action) => {
      state.marketTypeFav = action.payload.marketTypeFav;
    },
    updateCasinoGameFavs: (state, action) => {
      state.casinoGameFav = action.payload.casinoGameFav;
    },
    updateRecentCasinoGame: (state, action) => {
      state.recentCasinoGame = action.payload.recentCasinoGame;
    },
    updateMyCasinoGameList: (state, action) => {
      state.myCasinoGameList = action.payload.myCasinoGameList;
    },
    updateMarketFilters: (state, action) => {
      state.market_filters = action.payload.market_filters;
    },
    updateAvailableSportTypes: (state, action) => {
      state.available_sport_types = action.payload.available_sport_types;
    },
    updateSportHasGamesToday: (state, action) => {
      state.sport_hasGamesToday = action.payload.sport_hasGamesToday;
    },
    updateTopMatches: (state, action) => {
      state.top_matches = action.payload.top_matches;
    },
    updateRewardPromotion: (state, action) => {
      state.rewardPromotion = action.payload.rewardPromotion;
    },
    updateOpenTournamentDetail: (state, action) => {
      state.openTournamentDetail = action.payload.openTournamentDetail;
    },
    updateTournamentData: (state, action) => {
      state.tournamentData = action.payload.tournamentData;
    },
    updateOpenArchivedCampaign: (state, action) => {
      state.openArchivedCampaign = action.payload.openArchivedCampaign;
    },
    updateOpenCompletedTournament: (state, action) => {
      state.openCompletedTournament = action.payload.openCompletedTournament;
    },
    updateCompletedTournamentData: (state, action) => {
      state.completedTournamentData = action.payload.completedTournamentData;
    },
  },
});

export const {
  addAllEvents,
  updateEvents,
  updateSportTypeEvents,
  updateCoreData,
  updateTopMatches,
  updateLeagueGroups,
  updateBetGroup,
  updateBetTypes,
  updateTopBets,
  updateLeagues,
  updateSportCountries,
  updateLeagueEvents,
  updateSportTypeLeagueGroups,
  updateLeagueGroupLeagues,
  updateSportHighlights,
  updateAvailableSportTypes,
  updateMarketFilters,
  updateFavGamesList,
  updateMarketTypeFavs,
  updateCasinoGameFavs,
  updateSportHasGamesToday,
  updateRecentCasinoGame,
  updateMyCasinoGameList,
  updateRewardPromotion,
  updateOpenTournamentDetail,
  updateTournamentData,
  updateOpenArchivedCampaign,
  updateOpenCompletedTournament,
  updateCompletedTournamentData,
} = coreDataSlice.actions;
export default coreDataSlice.reducer;
